import { challengeDialog, challengeOverlay } from './CaptchaChallenge.style';

/**
 * The dead-end popup deliberately reuses the challenge's overlay and card.
 *
 * It replaces the challenge on screen, so a different width, radius or elevation would read as a
 * second unrelated dialog appearing rather than the same one changing its message — and would
 * have to keep its own copy of the z-index that puts both above every sheet in the app.
 */
export const failedOverlay = challengeOverlay;

export const failedDialog = `${challengeDialog} tw:items-center tw:gap-base tw:text-center`;

export const failedTitle = 'tw:text-16 tw:font-semibold tw:text-font';

export const failedMessage = 'tw:text-14 tw:font-regular tw:text-gray-dark';

/** Mobile body: the sheet supplies the header, so only the message and the action live here. */
export const failedSheetBody = 'tw:flex tw:flex-col tw:gap-base tw:px-base tw:pt-base tw:pb-base';
